import React from 'react';
import Layout from '../../components/layout';
import Health from '../../components/one-oh-one/Health';

const headerText = 'SUBSTANCE USE 101';

const OneOhOne = () => {
  return (
    <Layout
      headerText={headerText}
      heroFont="has-text-white"
      heroBg="dark-hero"
    >
      <Health path="/one-oh-one/health" />
    </Layout>
  );
};

export default OneOhOne;
